// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_Table__pOMih {
  display: block;
  margin-bottom: 513px;
  position: relative;
  z-index: 5;
  background-color: var(--app-bgc);
  padding: 10px;
  height: 1299px;
  overflow: hidden;
}

.Table_tableHeader__z1a2J {
  display: grid;
  grid-template-columns: 159px 137px 437px 159px 167px;
  grid-row-gap: 10px;
}

.Table_tableHeader__z1a2J {
  margin-bottom: 27px;
  font: var(--font-30);
}
.Table_tableHeader__z1a2J div:nth-child(1), .Table_tableHeader__z1a2J div:nth-child(4) {
  text-align: center;
}
.Table_tableHeader__z1a2J div:nth-child(5) {
  text-align: right;
}

.Table_tableContent__RzttJ {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Table_tableContent__RzttJ div {
  display: inline-flex;
  row-gap: 10px;
}

.Table_iconWrapper__HWq2z {
  width: 159px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  border-radius: 19px;
  position: relative;
}
.Table_iconWrapper__HWq2z .Table_forDisabled__NwHCp {
  position: absolute;
  right: 17px;
  bottom: 10px;
  border-radius: 50%;
  background-color: var(--Link_color, #1890FF);
  height: 52px;
  width: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Table_iconWrapper__HWq2z .Table_notActiveDisabled__Pwxes {
  background-color: #919090;
}

.Table_routeId__y8e8u {
  width: 137px;
  box-sizing: border-box;
}

.Table_rowItem__VzHsE {
  width: 159px;
  box-sizing: border-box;
}

.Table_arrival__QihTj {
  width: 167px;
  box-sizing: border-box;
}

.Table_routeId__y8e8u, .Table_rowItem__VzHsE, .Table_arrival__QihTj {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 19px;
  background: #000;
  font: var(--font-38-500);
  letter-spacing: 1px;
  padding: 0 25px;
}

.Table_arrival__QihTj {
  justify-content: right;
}

.Table_routeId__y8e8u {
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.2);
}

.Table_schemaName__76eIo {
  box-sizing: border-box;
  width: 437px;
  display: flex;
  align-items: center;
  padding: 0 25px;
  border-radius: 19px;
  background: #000;
  font: var(--font-30);
  min-height: 113px;
}

.Table_widerSchemaName__R5-04 {
  width: 597px;
}

.Table_pairRows__RXbIy {
  background-color: #232323;
}
.Table_pairRows__RXbIy .Table_gag__KNPPo {
  background-color: #232323;
}

.Table_notActive__rrPCf {
  color: #919090;
}

.Table_isNear__oPGye {
  color: #FFBC42;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,oBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AAEE;EACE,oBAAA;EACA,aAAA;AAAJ;;AAQA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAQE;EACE,yBAAA;AANJ;;AAUA;EACE,YAAA;EACA,sBAAA;AAPF;;AAUA;EACE,YAAA;EACA,sBAAA;AAPF;;AASA;EACE,YAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AANF;;AASA;EACE,sBAAA;AANF;;AASA;EACE,mBAAA;EACA,oCAAA;AANF;;AASA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AANF;;AAQA;EACE,YAAA;AALF;;AAYA;EACE,yBAAA;AATF;AAUE;EACE,yBAAA;AARJ;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;AATF","sourcesContent":[".Table {\n  display: block;\n  margin-bottom: 513px;\n  position: relative;\n  z-index: 5;\n  background-color: var(--app-bgc);\n  padding: 10px;\n  height: 1299px;\n  overflow: hidden;\n}\n\n.tableHeader {\n  display: grid;\n  grid-template-columns: 159px 137px 437px 159px 167px;\n  grid-row-gap: 10px;\n}\n\n.tableHeader {\n  margin-bottom: 27px;\n  font: var(--font-30);\n\n  div:nth-child(1), div:nth-child(4) {\n    text-align: center;\n  }\n\n  div:nth-child(5) {\n    text-align: right;\n  }\n}\n\n.tableContent {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  div {\n    display: inline-flex;\n    row-gap: 10px;\n  }\n}\n\n.row {\n  //height: 113px;\n}\n\n.iconWrapper {\n  width: 159px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #000;\n  border-radius: 19px;\n  position: relative;\n\n  .forDisabled {\n    position: absolute;\n    right: 17px;\n    bottom: 10px;\n    border-radius: 50%;\n    background-color: var(--Link_color, #1890FF);\n    height: 52px;\n    width: 52px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .notActiveDisabled {\n    background-color: #919090;\n  }\n}\n\n.routeId {\n  width: 137px;\n  box-sizing: border-box;\n}\n\n.rowItem {\n  width: 159px;\n  box-sizing: border-box;\n}\n.arrival {\n  width: 167px;\n  box-sizing: border-box;\n}\n\n.routeId, .rowItem, .arrival {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 19px;\n  background: #000;\n  font: var(--font-38-500);\n  letter-spacing: 1px;\n  padding: 0 25px;\n}\n\n.arrival {\n  justify-content: right;\n}\n\n.routeId {\n  border-radius: 19px;\n  background: rgba(255, 255, 255, 0.20);\n}\n\n.schemaName {\n  box-sizing: border-box;\n  width: 437px;\n  display: flex;\n  align-items: center;\n  padding: 0 25px;\n  border-radius: 19px;\n  background: #000;\n  font: var(--font-30);\n  min-height: 113px;\n}\n.widerSchemaName {\n  width: 597px;\n}\n\n.rowItem {\n\n}\n\n.pairRows {\n  background-color: #232323;\n  .gag {\n    background-color: #232323;\n  }\n}\n\n.notActive {\n  color: #919090;\n}\n\n.isNear {\n  color: #FFBC42;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Table": `Table_Table__pOMih`,
	"tableHeader": `Table_tableHeader__z1a2J`,
	"tableContent": `Table_tableContent__RzttJ`,
	"iconWrapper": `Table_iconWrapper__HWq2z`,
	"forDisabled": `Table_forDisabled__NwHCp`,
	"notActiveDisabled": `Table_notActiveDisabled__Pwxes`,
	"routeId": `Table_routeId__y8e8u`,
	"rowItem": `Table_rowItem__VzHsE`,
	"arrival": `Table_arrival__QihTj`,
	"schemaName": `Table_schemaName__76eIo`,
	"widerSchemaName": `Table_widerSchemaName__R5-04`,
	"pairRows": `Table_pairRows__RXbIy`,
	"gag": `Table_gag__KNPPo`,
	"notActive": `Table_notActive__rrPCf`,
	"isNear": `Table_isNear__oPGye`
};
export default ___CSS_LOADER_EXPORT___;
